<template>
  <el-tag :color="internalColor || '#FFFFFF'" :size="size">
    <span :style="{ color: contrastTextColor(internalColor) }">{{
      tagName
    }}</span></el-tag
  >
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { contrastTextColor } from 'src/util/colorUtils';

export default {
  name: 'tag-display',
  computed: {
    ...mapGetters('tags', ['getTags']),
  },
  props: {
    value: {
      type: [Number, String],
    },
    size: {
      type: String,
      default: () => {
        'small';
      },
    },
  },
  data() {
    return {
      internalValue: undefined,
      internalColor: undefined,
      tagName: '',
    };
  },
  watch: {
    value(n) {
      this.internalValue = parseInt(n);
      this.internalColor = '#fff';
      this.assignName();
    },
  },
  async created() {
    this.internalValue = this.value;
    await this.fetchTags();
    this.assignName();
  },
  methods: {
    ...mapActions('tags', ['fetchTags']),
    contrastTextColor,
    assignName() {
      const tag = this.getTags.find((tag) => tag.id === this.internalValue);
      if (tag) {
        this.tagName = tag.label;
        this.internalColor = tag.color;
      }
    },
  },
};
</script>
